<template>
  <div>
    <van-popup
      v-model="show"
      position="right"
      :style="{ width: '100%', height: '100%' }"
      duration="0.2"
    >
      <span @click="close" class="close"></span>
      <dl>
        <dt></dt>
        <dd>{{ url }}</dd>
      </dl>
      <div class="btn">
        <span @click="downloadView">{{ $t('下载') }}</span>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      url: ''
    }
  },
  mounted() {
    this.bus.$on('hideFileDown', () => {
      this.show = false
    })
    this.bus.$on('showFileDown', res => {
      this.show = true
      this.url = res.url
    })
  },
  methods: {
    close() {
      this.show = false
    },
    downloadView() {
      const url = this.url
      const fileType = url.substring(url.lastIndexOf('.') + 1)
      try {
        let options = {
          source: '新闻中心',
          fileType,
          url
        }
        window.bridge.onFileDownload(JSON.stringify(options))
      } catch (error) {
        console.log('调用APP下载方法失败')
        window.location.href = url
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';
.close {
  position: absolute;
  top: 0;
  left: 0;
  width: 1rem;
  height: 1rem;
  background: url('~@/assets/img/datel.png') no-repeat center;
  background-size: 0.2rem;
}
dl {
  overflow: hidden;
  dt {
    width: 1.2rem;
    height: 1.2rem;
    margin: 2.2rem auto 0.2rem;
    background: url('~@/assets/img-m/icon-file.png') no-repeat center;
    background-size: 100%;
  }
  dd {
    font-size: 0.26rem;
    line-height: 0.4rem;
    text-align: center;
    padding: 0.2rem 1rem;
  }
}
.btn {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  text-align: center;
  span {
    display: inline-block;
    width: 3rem;
    line-height: 0.7rem;
    margin: 0 auto 2rem;
    font-size: 0.3rem;
    color: #fff;
    @include linearBg();
    border-radius: 0.1rem;
  }
}
</style>
